import { flow } from 'mobx-state-tree';
import { DEFAULT_GROUP_ID, getDefaultGroupIdFromGroups } from '@utils/mst/organizationalHelpers';

/**
 * Format access code data for Create or Update APIs
 */
function formatAccessCode(data: any, organizationalGroups: any) {
  const {
    activatedAt,
    benefitsUrl,
    code,
    duration,
    durationType,
    expiredAt,
    customMemberType,
    limit,
    organizationId,
    orgGroupId,
  } = data;

  return {
    activatedAt: activatedAt ? new Date(activatedAt) : null,
    benefitsUrl,
    code,
    duration: durationType === 'none' ? null : duration,
    expiredAt: expiredAt ? new Date(expiredAt) : null,
    limit,
    metaData: {
      ...data.metaData,
      customMemberType,
    },
    organizationId: Number(organizationId),
    orgGroupId: Number(orgGroupId || getDefaultGroupIdFromGroups(organizationalGroups)),
  };
}

export default {
  actions: (self: any) => ({
    // TODO: clean up this function
    addAccessCodes(items = []) {
      self.accessCodes = self.accessCodes.merge(
        [...items.map((c: any) => {
          const org = self.organizations.get(c.organizationId || c.organization?.id);

          const orgGroupId = c.orgGroupId || c.organizationalGroups;
          const defaultOrganizationalGroup = c.defaultOrganizationalGroup || null;

          const finalGroupId = orgGroupId || (org?.defaultOrgGroupId || DEFAULT_GROUP_ID);

          return [c.id, {
            ...c,
            organization: c.organization.id,
            organizationalGroups: Number(finalGroupId),
            orgGroupId: orgGroupId ? Number(orgGroupId) : null,
            defaultOrganizationalGroup,
          }];
        })],
      );
    },

    createAccessCode: flow(function* createAccessCode(data) {
      const accessCode = formatAccessCode(data, self.organizationalGroups);

      const result = yield self.hades.request(
        'accessCode.create',
        accessCode,
      );

      const orgGroupId = Number(data.orgGroupId || getDefaultGroupIdFromGroups(self.organizationalGroups));

      self.accessCodes.set(result.id, {
        ...result,
        organization: result.organizationId,
        organizationalGroups: orgGroupId,
        orgGroupId,
        defaultOrganizationalGroup: result.defaultOrganizationalGroup || null,
      });

      return result;
    }),

    updateAccessCode: flow(function* updateAccessCode(data) {
      const accessCode = formatAccessCode(data, self.organizationalGroups);

      const result = yield self.hades.request(
        'accessCode.update',
        {
          id: data.id,
          ...accessCode,
        },
      );

      const orgGroupId = Number(data.orgGroupId || getDefaultGroupIdFromGroups(self.organizationalGroups));

      self.accessCodes.set(result.id, {
        ...result,
        organization: result.organizationId,
        organizationalGroups: orgGroupId,
        orgGroupId,
        defaultOrganizationalGroup: result.defaultOrganizationalGroup || null,
      });

      return result;
    }),

    getRedemptionCounts: flow(function* getRedemptionCounts() {
      const redemptionCounts: Array<{ code: string; count: number }> = yield self.hades.get('accessCodes/redemptionCounts');
      return redemptionCounts;
    }),
  }),
};
